var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCrosshairs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8C5.5 6.625 6.59375 5.5 8 5.5C9.375 5.5 10.5 6.625 10.5 8C10.5 9.40625 9.375 10.5 8 10.5C6.59375 10.5 5.5 9.40625 5.5 8ZM8 0C8.53125 0 9 0.46875 9 1V2.09375C11.5 2.53125 13.4688 4.5 13.9062 7H15C15.5312 7 16 7.46875 16 8C16 8.5625 15.5312 9 15 9H13.9062C13.4688 11.5312 11.5 13.5 9 13.9375V15C9 15.5625 8.53125 16 8 16C7.4375 16 7 15.5625 7 15V13.9375C4.46875 13.5 2.5 11.5312 2.0625 9H1C0.4375 9 0 8.5625 0 8C0 7.46875 0.4375 7 1 7H2.0625C2.5 4.5 4.46875 2.53125 7 2.09375V1C7 0.46875 7.4375 0 8 0ZM4 8C4 10.2188 5.78125 12 8 12C10.1875 12 12 10.2188 12 8C12 5.8125 10.1875 4 8 4C5.78125 4 4 5.8125 4 8Z",
    fill: "inherit",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCrosshairs);
export default __webpack_public_path__ + "static/media/location-crosshairs.08a08fdeca673c3b3e84400624b0704b.svg";
export { ForwardRef as ReactComponent };